// extracted by mini-css-extract-plugin
export var cartIcon = "_oq-0";
export var cartIconContainer = "_oq-1";